export const IS_SOC_SIM_BANNER_DISMISSED_KEY = 'isSocSimBannerDismissed';
